import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#oem-level-finance-app', App);
